module.exports = __webpack_public_path__ + "img/classic_season20_2.6425bc4c.jpg";